import { SpaceKind, SpaceNodeKind } from 'shared';
import { create } from 'zustand';

import { DataRoomModalType } from '../enums/data-room-modal-type.enum';

// A folder or a file a modal acts on, with the kind of space whose routes serve it.
export type DataRoomModalNode = {
  id: string;
  kind: SpaceNodeKind;
  name: string;
  spaceKind: SpaceKind;
};

// A Vault file, which its own routes serve: they take the folder and the stored link back.
export type DataRoomModalVaultFile = {
  folderId: string;
  id: string;
  link: string;
  name: string;
};

export type DataRoomModalMetadata = {
  node?: DataRoomModalNode;
  spaceId: string;
  vaultFile?: DataRoomModalVaultFile;
};

type OpenModalPayload = {
  metadata?: DataRoomModalMetadata;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  type: DataRoomModalType;
};

type DataRoomModalStoreState = {
  handleAccept: () => void;
  handleDismiss: () => void;
  isOpen: boolean;
  metadata: DataRoomModalMetadata | null;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  openModal: (payload: OpenModalPayload) => void;
  type: DataRoomModalType;
};

const INITIAL_STATE: Omit<DataRoomModalStoreState, 'handleAccept' | 'handleDismiss' | 'openModal'> =
  {
    isOpen: false,
    metadata: null,
    onAcceptCallback: undefined,
    onDismissCallback: undefined,
    type: DataRoomModalType.CREATE_SPACE,
  };

export const DataRoomModalStore = create<DataRoomModalStoreState>()((set, get) => ({
  ...INITIAL_STATE,

  handleAccept: () => {
    const callback = get().onAcceptCallback;
    callback?.();
    set(INITIAL_STATE);
  },

  handleDismiss: () => {
    const callback = get().onDismissCallback;
    callback?.();
    set(INITIAL_STATE);
  },

  openModal: ({ metadata, type, onAcceptCallback, onDismissCallback }) => {
    set({
      isOpen: true,
      metadata: metadata ?? null,
      onAcceptCallback,
      onDismissCallback,
      type,
    });
  },
}));
